const { trapFocus } = await import(
    window._resolveImport?.("helper") || "helper"
);
const { MenuDrawer } = await import(
    window._resolveImport?.("menu-drawer") || "menu-drawer"
);

const __hasDropdown = (drawer) =>
    drawer.classList.contains("lg:header-drawer__dropdown");
const __behaveDropdown = (drawer) =>
    window.innerWidth >= 990 && __hasDropdown(drawer);

const switchers = [
    {
        target: ".localization-language-wrapper",
        source: ".localization-language-wrapper:not(:empty)",
    },
    {
        target: ".localization-currency-wrapper",
        source: ".localization-currency-wrapper:not(:empty)",
    },
];

class HeaderDrawer extends MenuDrawer {
    constructor() {
        super();

        if (this.dataset.expand == "on_hover") {
            this.handles = {
                ...this.handles,
                "mouseenter::details details": (event) => {
                    const d = event.target;

                    if (!__behaveDropdown(this)) return;

                    d.__drawerClose = null;
                    setTimeout(() => d?.__drawerOpen?.(), 200);
                    d.__drawerOpen = () => {
                        d.classList.add("menu-opening");
                        d.open = true;
                    };
                },
                "mouseleave::details details": (event) => {
                    const d = event.target;

                    if (!__behaveDropdown(this)) return;

                    d.__drawerOpen = null;
                    setTimeout(() => d?.__drawerClose?.(), 200);
                    d.__drawerClose = () => {
                        d.classList.remove("menu-opening");
                        d.open = false;
                    };
                },
            };
        }
    }

    connectedCallback() {
        super.connectedCallback?.();

        // add currency and language switchers into drawer
        switchers.forEach(({ target, source }) => {
            const targetElement = this.querySelector(target);

            if (targetElement && !targetElement.innerHTML) {
                targetElement.insertAdjacentHTML(
                    "afterbegin",
                    document.querySelector(source)?.innerHTML
                );
            }
            document.querySelector(source)?.textContent == "undefined"
                ? (document.querySelector(source).style.visibility = "hidden")
                : "";
        });
    }

    openMenuDrawer(summary) {
        this.header = this.header || this.closest(".shopify-section");
        this.borderOffset =
            this.borderOffset ||
            this.closest(".header-wrapper").classList.contains(
                "header-wrapper--border-bottom"
            )
                ? 1
                : 0;
        document.documentElement.style.setProperty(
            "--header-bottom-position",
            `${parseInt(
                this.header.getBoundingClientRect().bottom - this.borderOffset
            )}px`
        );

        setTimeout(() => {
            window.requestAnimationFrame(() => {
                this.mainDetailsToggle.classList.add("menu-opening");
            });
            this.mainDetailsToggle.open = true;
            trapFocus(this.mainDetailsToggle, summary);
        });

        summary.setAttribute("aria-expanded", true);
        document.body.classList.add("overflow-hidden-mobile");
    }

    onSummaryClick(event) {
        const summary = event.currentTarget;

        super.onSummaryClick(event);
        // close opened details except the current one
        this.querySelectorAll("details[open]").forEach((d) => {
            if (d.contains(summary)) return;
            d.open = false;
            d.classList.remove("menu-opening");
        });
    }
}

export { HeaderDrawer };
